import { Text } from "../../../../../components/common/typography";

export function TypingIndicator() {
  return (
    <div
      className="flex w-fit items-center gap-2 rounded-2xl rounded-bl-sm bg-bgWhite px-4 py-3"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-1.5">
        <span className="size-2 animate-bounce rounded-full bg-textMuted" />
        <span className="size-2 animate-bounce rounded-full bg-textMuted [animation-delay:120ms]" />
        <span className="size-2 animate-bounce rounded-full bg-textMuted [animation-delay:240ms]" />
      </div>
      <Text variant="bodyXs" tone="muted" inline>
        Procurtal is thinking…
      </Text>
    </div>
  );
}
